(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ag-exchange"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ag-exchange')) {
  customElements.define('ag-exchange', class extends HTMLElement {
    connectedCallback() {
      this.stopped = false;
      this.renderRates();
      this.querySelector('[data-fullscreen]').onclick = () => {
        const target = document.documentElement;
        if (target.requestFullscreen) target.requestFullscreen().catch(() => { this.querySelector('[data-fullscreen-error]').hidden = false; });
        else this.querySelector('[data-fullscreen-error]').hidden = false;
      };
      if (this.dataset.editor !== 'true') this.timer = setTimeout(() => this.refresh(), 15000);
    }
    disconnectedCallback() { this.stopped = true; clearTimeout(this.timer); if(this.controller) this.controller.abort(); }
    renderRates() {
      let invalid = false;
      this.querySelectorAll('tbody tr').forEach(row => {
        const buy = row.dataset.buy.trim().replace(',', '.');
        const sell = row.dataset.sell.trim().replace(',', '.');
        const pattern = /^\d{1,5}(\.\d{1,4})?$/;
        const valid = pattern.test(buy) && pattern.test(sell) && Number(buy) > 0 && Number(sell) >= Number(buy);
        if (!valid && (buy || sell)) invalid = true;
        row.querySelector('[data-rate=buy]').textContent = valid ? Number(buy).toFixed(4).replace('.', ',') : '—';
        row.querySelector('[data-rate=sell]').textContent = valid ? Number(sell).toFixed(4).replace('.', ',') : '—';
      });
      this.querySelector('[data-invalid]').hidden = !invalid;
    }
    async refresh() {
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 10000);
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('_ag_refresh', Date.now().toString());
        const response = await fetch(url.toString(), {cache:'no-store', signal:this.controller.signal});
        if (!response.ok) throw new Error('HTTP');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('ag-exchange [data-content]');
        if (!next || !next.querySelector('tbody tr')) throw new Error('Content');
        if (this.stopped) return;
        this.querySelector('[data-content]').innerHTML = next.innerHTML;
        this.querySelector('[data-offline]').hidden = true;
        this.renderRates();
      } catch (e) {
        if (!this.stopped) {
          this.querySelector('[data-offline]').hidden = false;
          this.querySelectorAll('[data-rate]').forEach(cell => { cell.textContent = '—'; });
        }
      } finally {
        clearTimeout(timeout);
        if (!this.stopped) this.timer = setTimeout(() => this.refresh(), 15000);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.ag-reviews__header a[href^="#"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    const details = target?.querySelector('details');
    if (details) details.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
